import * as Yup from 'yup';
import {IntlShape} from 'react-intl';

type Category = {
  id: number;
  name: string;
};

export interface News {
  category: string;
  text: string;
  link: string | null;
  popup: string | null;
  startDate: string;
  endDate: string | null;
}

export interface NewsFromApi {
  id: number;
  title: string;
  news: string | null;
  know_more: string | null;
  for_client: string | null;
  start_date: string;
  end_date: string | null;
  category: Category;
}

export interface AdminNewsFormValues {
  category_id: number;
  start_date: string;
  end_date: string;
  title: string;
  description?: string;
  type: string;
  frequency?: string;
  moreType: string;
  news: string;
}

export interface NewsCategory {
  id: number;
  title: string;
}

export const NewsSchema = (intl: IntlShape): Yup.SchemaOf<AdminNewsFormValues> => {
  return Yup.object().shape({
    category_id: Yup.number().required(intl.formatMessage({id: 'FIELD.REQUIRED'})),
    start_date: Yup.string().required(intl.formatMessage({id: 'FIELD.REQUIRED'})),
    end_date: Yup.string().required(intl.formatMessage({id: 'FIELD.REQUIRED'})),
    moreType: Yup.string().required(intl.formatMessage({id: 'FIELD.REQUIRED'})),
    news: Yup.string()
      .when('moreType', {
        is: 'none',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema
            .url(intl.formatMessage({id: 'FIELD.FORMAT.URL'}))
            .required(intl.formatMessage({id: 'FIELD.REQUIRED'})),
      })
      .required(intl.formatMessage({id: 'FIELD.REQUIRED'})),
    title: Yup.string().required(intl.formatMessage({id: 'FIELD.REQUIRED'})),
    description: Yup.string().when('type', {
      is: 'popup',
      then: (schema) => schema.required(intl.formatMessage({id: 'FIELD.REQUIRED'})),
      otherwise: (schema) => schema.notRequired(),
    }),
    type: Yup.string().required(intl.formatMessage({id: 'FIELD.REQUIRED'})),
    frequency: Yup.string().when('type', {
      is: 'popup',
      then: (schema) => schema.required(intl.formatMessage({id: 'FIELD.REQUIRED'})),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
};
